import React from 'react';
import { MaintenanceEntitySection } from './MaintenanceEntitySection';

const SiteMaintenance = () => (
  <div className="space-y-6 max-w-6xl">
    <div>
      <h2 className="text-xl font-semibold text-gray-900">Site maintenance</h2>
    
    </div>
    <MaintenanceEntitySection
      apiType="Site"
      addTitle="Add site"
      valueLabel="Site name (value)"
      valuePlaceholder="e.g. Site A"
      codePlaceholder="Optional — defaults to name"
      listHeading="Sites"
      emptyHint="No sites yet. Use the form on the left."
      deleteModalLabel="site"
    />
  </div>
);

export default SiteMaintenance;
